import type { ButtonProps } from '@polyseme/design-system';

import { Button as BaseButton } from '@polyseme/design-system';
import { cn } from '@polyseme/utils/cn/cn-utils';

export const Button = ({ className, ...props }: ButtonProps) => {
  return (
    <BaseButton
      className={cn('h-12 !rounded-full px-6', className)}
      {...props}
    />
  );
};
